import { SocketState } from 'src/types/redux';
import {
  SOCKET_CONNECTED,
  UNREAD_COUNT,
  NOTIFICATION,
  SocketActionType,
} from '../types/socketType';

const initialState: SocketState = {
  unReadCount: null,
  notFirst: false,
  socket: null,
  notifications: [],
};

export const socketReducer = (
  state = initialState,
  action: SocketActionType
): SocketState => {
  switch (action?.type) {
    case SOCKET_CONNECTED:
      return {
        ...state,
        socket: action?.payload,
        notFirst: true,
      };
    case UNREAD_COUNT:
      return {
        ...state,
        unReadCount: action?.payload,
      };
    case NOTIFICATION:
      return {
        ...state,
        notifications: action?.payload,
      };
    default:
      return state;
  }
};
